import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Layout } from "antd";
import NewHeaderView from "./NewHeaderView";
import OnboardingCustomerService from "../../services/api/OnboardingCustomerService";

const { Content } = Layout;

const onboardingCustomerService = new OnboardingCustomerService();

const LayoutView = () => {
  const location = useLocation();
  const isAuthenticated = !!localStorage.getItem("access_token");
  const isOnboarding = location.pathname.includes("onboarding");

  useEffect(() => {
    const checkOnboarding = async () => {
      if (isAuthenticated) {
        const data = await onboardingCustomerService.checkHasOnboarding();
        if (!data?.details?.hasOnboarding && !isOnboarding) {
          window.location.href = "/onboarding";
        }
      }
    };

    checkOnboarding();
  }, []);

  return (
    <div>
      {isAuthenticated ? (
        <Layout>
          <Layout>
            <Layout>
              {!isOnboarding && <NewHeaderView />}
              <Content
                style={{ padding: 12, backgroundColor: "white" }}
                id="main_content"
                className={!isOnboarding ? "ant-layout-content-gray" : ""}
              >
                <Outlet />
              </Content>
            </Layout>
          </Layout>
        </Layout>
      ) : (
        <Layout>
          <NewHeaderView />
          <Content
            style={{ padding: 12, minHeight: "80vh", backgroundColor: "white" }}
            className="ant-layout-content-white"
          >
            <Outlet />
          </Content>
        </Layout>
      )}
    </div>
  );
};

export default LayoutView;